import { Link } from "react-router-dom";
import { cn } from "@verse_core/shared_components/ClassName";

const TABS = [
  { value: "login", label: "LOG IN", to: "/password-login?type=provider" },
  { value: "signup", label: "SIGN UP", to: "/sign-up" },
] as const;

/** The "LOG IN | SIGN UP" tabs at the top of the login and sign-up cards. */
export const AuthTabs = ({ selected }: { selected: "login" | "signup" }) => (
  <nav aria-label="Log in or sign up" className="tw-flex tw-w-full">
    {TABS.map(({ value, label, to }) => {
      const active = value === selected;
      return (
        <Link
          key={value}
          to={to}
          aria-current={active ? "page" : undefined}
          className={cn(
            "tw-flex tw-h-[46px] tw-flex-1 tw-items-center tw-justify-center tw-px-[16px] tw-font-sohne-mono tw-text-[14px] tw-leading-[1.4] tw-tracking-[0.7px] hover:tw-no-underline",
            active
              ? "tw-border-0 tw-border-b-2 tw-border-solid tw-border-verse-text-brand tw-text-verse-text-brand"
              : "tw-text-verse-text-tertiary",
          )}
        >
          {label}
        </Link>
      );
    })}
  </nav>
);
